export const ORDER_STATUSES = [
  "PENDING",
  "VENDOR_ACCEPTED",
  "PREPARING",
  "READY_FOR_PICKUP",
  "DRIVER_ASSIGNED",
  "PICKED_UP",
  "ON_THE_WAY",
  "DELIVERED",
];

export const VENDOR_NEXT = {
  PENDING: "VENDOR_ACCEPTED",
  VENDOR_ACCEPTED: "PREPARING",
  PREPARING: "READY_FOR_PICKUP",
};

export const DRIVER_NEXT = {
  DRIVER_ASSIGNED: "PICKED_UP",
  PICKED_UP: "ON_THE_WAY",
  ON_THE_WAY: "DELIVERED",
};

export const STATUS_LABELS = {
  PENDING: "Pending",
  VENDOR_ACCEPTED: "Accepted",
  PREPARING: "Preparing",
  READY_FOR_PICKUP: "Ready for pickup",
  DRIVER_ASSIGNED: "Driver assigned",
  PICKED_UP: "Picked up",
  ON_THE_WAY: "On the way",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const ACTIVE_STATUSES = [
  "PENDING",
  "VENDOR_ACCEPTED",
  "PREPARING",
  "READY_FOR_PICKUP",
  "DRIVER_ASSIGNED",
  "PICKED_UP",
  "ON_THE_WAY",
];

// Vendor kanban columns
export const VENDOR_COLUMNS = [
  { key: "PENDING", title: "New" },
  { key: "VENDOR_ACCEPTED", title: "Accepted" },
  { key: "PREPARING", title: "Preparing" },
  { key: "READY_FOR_PICKUP", title: "Ready" },
  { key: "OUT", title: "Out for delivery" },
];

export function statusLabel(status) {
  return STATUS_LABELS[status] ?? status;
}

export function formatRands(n) {
  return `R${(Number(n) || 0).toFixed(2)}`;
}

export function shortId(id) {
  return `#${String(id || "").slice(-6).toUpperCase()}`;
}

export function statusTone(status) {
  if (status === "DELIVERED") return "text-[hsl(var(--success))]";
  if (status === "CANCELLED" || status === "REFUNDED") return "text-destructive";
  if (status === "PENDING") return "text-[hsl(var(--warning))]";
  return "text-primary";
}
